import React from 'react';
import { Box, Typography, Link, IconButton } from '@mui/material';

const Footer: React.FC = () => (
  <Box
    component="footer"
    sx={{
      width: '100%',
      py: { xs: 4, md: 5 },
      mt: 0,
      background:
        'linear-gradient(180deg, #1a1412 0%, #2a201c 100%)',
      color: 'rgba(255,255,255,0.85)',
      textAlign: 'center',
    }}
  >
    <Typography
      sx={{
        fontFamily: '"Fraunces", Georgia, serif',
        fontWeight: 600,
        color: '#fff',
        mb: 1,
        fontSize: '1.25rem',
      }}
    >
      Hello Gassy&apos;z
    </Typography>
    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mb: 2 }}>
      Votre fournisseur de pâtes — Dakar, Sénégal
    </Typography>
    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
      <Link href="tel:+221785219793" underline="hover" sx={{ color: 'inherit' }}>
        +221 78 521 97 93
      </Link>
      {' · '}
      <Link href="tel:+221711125656" underline="hover" sx={{ color: 'inherit' }}>
        +221 71 112 56 56
      </Link>
      {' · '}
      <Link href="mailto:hellogassy@gmail.com" underline="hover" sx={{ color: 'inherit' }}>
        hellogassy@gmail.com
      </Link>
    </Typography>

    <Box sx={{ mt: 2.5, display: 'flex', justifyContent: 'center', gap: 1.5 }}>
      <IconButton component="a" href="https://instagram.com/hellogassy" target="_blank" rel="noopener" aria-label="Instagram">
        <img src="/icons/instagram.png" alt="Instagram" style={{ width: 28, height: 28 }} />
      </IconButton>
      <IconButton component="a" href="https://facebook.com/hellogassy" target="_blank" rel="noopener" aria-label="Facebook">
        <img src="/icons/facebook.png" alt="Facebook" style={{ width: 28, height: 28 }} />
      </IconButton>
      <IconButton component="a" href="https://snapchat.com/add/hellogassy" target="_blank" rel="noopener" aria-label="Snapchat">
        <img src="/icons/snapchat.png" alt="Snapchat" style={{ width: 28, height: 28 }} />
      </IconButton>
      <IconButton component="a" href="https://tiktok.com/@hellogassy" target="_blank" rel="noopener" aria-label="TikTok">
        <img src="/icons/tiktok.png" alt="TikTok" style={{ width: 28, height: 28 }} />
      </IconButton>
    </Box>

    <Box sx={{ mt: 2.5 }}>
      <Link href="/politique-confidentialite" underline="hover" sx={{ mx: 1, color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>
        Confidentialité
      </Link>
      <span style={{ color: 'rgba(255,255,255,0.35)' }}>|</span>
      <Link href="/conditions-utilisation" underline="hover" sx={{ mx: 1, color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>
        Conditions
      </Link>
    </Box>

    <Typography variant="caption" sx={{ display: 'block', mt: 2, color: 'rgba(255,255,255,0.4)' }}>
      © {new Date().getFullYear()} Hello Gassy&apos;z
    </Typography>
  </Box>
);

export default Footer;
